import {
  ASSIGN_PERMISSION,
  ASSIGN_PERMISSION_FAILED,
  ASSIGN_PERMISSION_SUCCESS,
  GET_PERMISSIONS,
  GET_PERMISSIONS_FAILED,
  GET_PERMISSIONS_SUCCESS,
} from "./actionTypes"

export const getPermissions = params => ({
  type: GET_PERMISSIONS,
  payload: params,
})

export const getPermissionsSuccess = response => ({
  type: GET_PERMISSIONS_SUCCESS,
  payload: response,
})

export const getPermissionsFailed = error => ({
  type: GET_PERMISSIONS_FAILED,
  payload: error,
})

export const assignPermission = params => ({
  type: ASSIGN_PERMISSION,
  payload: params,
})

export const assignPermissionSuccess = response => ({
  type: ASSIGN_PERMISSION_SUCCESS,
  payload: response,
})

export const assignPermissionFailed = error => ({
  type: ASSIGN_PERMISSION_FAILED,
  payload: error,
})
